import React from 'react'
import { Link } from 'react-router-dom'
import PalexLogo from '../../assests/img/logo.png'
import '../../assests/styles/onboarding/landing.scss'
import { routes } from '../../constantes/routes'

const Landing = () => {
  return (
    <div className='landing'>
      <img className='logo mb-80' src={PalexLogo} alt='Palex Logo'></img>
      <div>
        <Link to={routes.LOGIN}>
          <button className='btn-landing' id='animate-area'>
            GO
          </button>
        </Link>
      </div>
    </div>
  )
}

export default Landing
